import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=0d235930&scoped=true&"
var script = {}
import style0 from "./ServerError.vue?vue&type=style&index=0&id=0d235930&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d235930",
  null
  
)

export default component.exports